import { useState } from "react";
import Footer from "../../components/Footer/Footer"
import Header from "../../components/Header/Header"
import WhatsappFloatingButton from "../../components/WhatsappFloatingButton/WhatsappFloatingButton"
import { BUSINESS_INDUSTRIES, CITIES, WHATSAPP_LINK } from '../../utils/constants';
import {
  QuotationForm as QuotationFormStyled,
  FormWrapper,
  RequestQuotationButton,
  SmallTitle,
  Wrapper,
  QuotationFormWrapper,
  ProductListWrapper,
  ProductImage,
  QuotationCardContent
} from './QuotationForm.styled';
import Form from 'react-bootstrap/Form';
import { FaWhatsapp } from 'react-icons/fa'
import kebabToTitleCase from "../../utils/kebabToTitleCase";
import {
  QuotationCard,
  ProductName,
  ProductCategory,
} from '../../components/QuotationOverlay/QuotationOverlay.styled';

const QuotationForm = () => {
  const products = JSON.parse(localStorage.getItem('products')) || {};
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [telephone, setTelephone] = useState('');
  const [city, setCity] = useState('');
  const [businessIndustry, setBusinessIndustry] = useState('');

  const onRequestQuotation = () => {
    if(!name || !email || !companyName || !businessIndustry || !city || !telephone) {
      alert('Mohon isi semua informasi kontak sebelum mengirim permintaan kutipan.');
      return;
    }
    let textFormat = `Halo saya ${name}.%0A` +
                   `Email saya: ${email}.%0A` +
                   `Nomor telepon saya: ${telephone}.%0A` +
                   `Saya tinggal di ${city}.%0A` +
                   `Saya dari ${companyName} dari industri ${businessIndustry}.%0A` +
                   `Saya ingin memesan:%0A`;
    Object.keys(products).forEach((productId, i) => {
      const product = products[productId];
      const unit = product.unit || 'pcs';
      const variants = product?.variants || [];
      variants.forEach((variant) => {
        const quantity = parseInt(variant.quantity) || 0;
        console.log('variants', quantity);
        if(quantity > 0) {
          if(i === Object.keys(products).length - 1) {
            textFormat += `Produk: ${product?.name}: Varian: ${variant?.name} Qty: ${quantity} ${unit}.`;
          } else {
            textFormat += `Produk: ${product?.name}: Varian: ${variant?.name} Qty: ${quantity} ${unit}%0A`;
          }
          
        }
      })
    });

    // Delete local storage products after sending
    localStorage.removeItem('products');

    // Open WhatsApp with the formatted text
    window.open(`${WHATSAPP_LINK}?text=${textFormat}`, '_blank', 'noopener,noreferrer');
  }

  const renderProductsAndQuantities = () => {
    if (Object.keys(products).length === 0) {
      return <p>Tidak ada produk yang ditambahkan</p>;
    } else {
      return (
        Object.keys(products).length > 0 && Object.keys(products).flatMap((productId) => {
          const product = products[productId];
          const unit = product.unit || 'pcs';
          return product?.variants
            .filter((variant) => parseInt(variant.quantity) > 0) // 👈 only keep variants with quantity > 0
            .map((variant, i) => {
              const quantity = parseInt(variant.quantity) || 0;
              return (
                <QuotationCard key={`${product?.name}-${variant.name}`}>
                  <ProductImage src={variant.image} alt={product.name} />
                  <QuotationCardContent>
                    <ProductName>{product.name}</ProductName>
                    <ProductCategory>{variant.name}</ProductCategory>
                    <ProductCategory>{kebabToTitleCase(product.category)}</ProductCategory>
                    <ProductCategory style={{fontSize: 12}}>{`Qty: ${quantity} ${unit}`}</ProductCategory>
                  </QuotationCardContent>
                </QuotationCard>
              )
          });
        })
      )
    }
  }

  return (
    <>
      <Header />
      <Wrapper>
        <ProductListWrapper>
          <SmallTitle>Produk & Kuantitas</SmallTitle>
          {renderProductsAndQuantities()}
        </ProductListWrapper>
        <QuotationFormWrapper>
          <QuotationFormStyled>
            <SmallTitle>Informasi Kontak</SmallTitle>
            <FormWrapper>
              <Form.Group className="mb-3">
                <Form.Label>Nama</Form.Label>
                <Form.Control type="text" value={name} onChange={(evt) => setName(evt.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control type="text" value={email} onChange={(evt) => setEmail(evt.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nama perusahaan</Form.Label>
                <Form.Control type="text" value={companyName} onChange={(evt) => setCompanyName(evt.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Nomor telepon</Form.Label>
                <Form.Control type="tel" value={telephone} onChange={(evt) => setTelephone(evt.target.value)} />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Domisili</Form.Label>
                <Form.Select value={city} onChange={(evt) => setCity(evt.target.value)} placeholder="Pilih kota">
                  <option value="" disabled>
                    Pilih kota
                  </option>
                  {CITIES.map((city) => (
                    <option key={city} value={city}>
                      {city}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Industri perusahaan</Form.Label>
                <Form.Select value={businessIndustry} onChange={(evt) => setBusinessIndustry(evt.target.value)}>
                  <option value="" disabled>
                    Pilih industri
                  </option>
                  {BUSINESS_INDUSTRIES.map((industry) => (
                    <option key={industry} value={industry}>
                      {industry}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </FormWrapper>
          </QuotationFormStyled>
          <div className="d-flex justify-content-center align-items-center mb-4">
            <RequestQuotationButton onClick={onRequestQuotation}>
              <FaWhatsapp size={20} color="#fff" />
              Submit Quotation
            </RequestQuotationButton>
          </div>
        </QuotationFormWrapper>
      </Wrapper>
      
      <Footer />
      <WhatsappFloatingButton />
    </>
  )
}

export default QuotationForm;